import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}
  /**
   * CanActivate guard that prevents users from accessing the admin page without logging in as an incubator.
   * @param route The route that the user is trying to access.
   * @param state The state of the router.
   * @returns A boolean or UrlTree indicating whether the user is allowed to access the page, or a redirect to the login page.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Check if the user is logged in as an incubator.
    // If they are, allow them to access the page.
    // If they are not, redirect them to the incubator login page.
    if (sessionStorage.getItem('incubator') != null) {
      return true;
    } else {
      this.router.navigateByUrl('/incubator-list');
      return false;
    }
  }
}
